var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{staticClass:"account"},[_c('registration-card',[_c('card-header',{attrs:{"formName":_vm.getTitle}}),_c('AccountLockedForm',{attrs:{"username":_vm.getEmailParam,"sendOtp":_vm.sendOtp}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }